import React from "react";
import { Dropdown } from "react-bootstrap";
import "./PalletListDropdown.css";
import { OrangeArrow } from "../../../svgFiles/OrangeArrow";
import useTranslator from "../../../hooks/useTranslator";
import { formatPalletName } from "../../../helpers/Utils";

const PalletListDropdown = ({ pallets = [], onDelete }) => {
  // Translation
  const { _t } = useTranslator();

  return (
    <div>
      <label className="cmn_label form-label">
        {_t("selected_pallets", "Selected Pallets")}
      </label>
      <Dropdown className="mb-3 select_status palletDropdown">
        <Dropdown.Toggle
          variant="unset"
          id="pallet-dropdown"
          className="d-flex align-items-center justify-content-between"
        >
          {_t("selected_pallets", "Selected Pallets")}{" "}
          <strong className="flex-grow-1 text-start ms-1">
            ({pallets.length})
          </strong>{" "}
          {OrangeArrow}
        </Dropdown.Toggle>

        <Dropdown.Menu
          className="p-0"
          style={{ minWidth: "220px", width: "100%" }}
        >
          <ul className="p-0 m-0">
            {pallets.length === 0 ? (
              <div className="text-muted text-center noPallet">
                <p className="m-0">
                  {_t("no_pallet_selected", "No pallet selected")}
                </p>
              </div>
            ) : (
              pallets.map((pallet, index) => (
                <li
                  key={index}
                  className="d-flex justify-content-between align-items-center "
                >
                  <span>{formatPalletName(pallet.pallet_id)}</span>
                  <span>
                    {Number(pallet.pallet_kg_entered).toFixed(2) } {_t("kg", "Kg")}
                  </span>
                  <span>
                    {pallet.pallet_total_cases} {_t("cases", "Cases")}
                  </span>

                  <div
                    type="button"
                    onClick={() => onDelete(index)}
                    className="cursor-pointer"
                  >
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 15C2.04167 15 1.64945 14.8369 1.32334 14.5108C0.997225 14.1847 0.833892 13.7922 0.833336 13.3333V2.5C0.597225 2.5 0.399447 2.42 0.240003 2.26C0.0805585 2.1 0.000558429 1.90222 2.87356e-06 1.66667C-0.000552682 1.43111 0.0794474 1.23333 0.240003 1.07333C0.400559 0.913333 0.598336 0.833333 0.833336 0.833333H4.16667C4.16667 0.597222 4.24667 0.399445 4.40667 0.24C4.56667 0.0805556 4.76445 0.000555556 5 0H8.33334C8.56945 0 8.7675 0.0800001 8.9275 0.24C9.0875 0.4 9.16722 0.597778 9.16667 0.833333H12.5C12.7361 0.833333 12.9342 0.913333 13.0942 1.07333C13.2542 1.23333 13.3339 1.43111 13.3333 1.66667C13.3328 1.90222 13.2528 2.10028 13.0933 2.26083C12.9339 2.42139 12.7361 2.50111 12.5 2.5V13.3333C12.5 13.7917 12.3369 14.1842 12.0108 14.5108C11.6847 14.8375 11.2922 15.0006 10.8333 15H2.5ZM5 11.6667C5.23611 11.6667 5.43417 11.5867 5.59417 11.4267C5.75417 11.2667 5.83389 11.0689 5.83334 10.8333V5C5.83334 4.76389 5.75334 4.56611 5.59334 4.40667C5.43334 4.24722 5.23556 4.16722 5 4.16667C4.76445 4.16611 4.56667 4.24611 4.40667 4.40667C4.24667 4.56722 4.16667 4.765 4.16667 5V10.8333C4.16667 11.0694 4.24667 11.2675 4.40667 11.4275C4.56667 11.5875 4.76445 11.6672 5 11.6667ZM8.33334 11.6667C8.56945 11.6667 8.7675 11.5867 8.9275 11.4267C9.0875 11.2667 9.16722 11.0689 9.16667 10.8333V5C9.16667 4.76389 9.08667 4.56611 8.92667 4.40667C8.76667 4.24722 8.56889 4.16722 8.33334 4.16667C8.09778 4.16611 7.9 4.24611 7.74 4.40667C7.58 4.56722 7.5 4.765 7.5 5V10.8333C7.5 11.0694 7.58 11.2675 7.74 11.4275C7.9 11.5875 8.09778 11.6672 8.33334 11.6667Z"
                        fill="#FF4E4E"
                      />
                    </svg>
                  </div>
                </li>
              ))
            )}
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default PalletListDropdown;
